import { ReactElement } from 'react'
import ChatBubble from './ChatBubble'

export default function InboundChatBubble({
  text,
  userName,
  time,
  needsHuman,
}: {
  text: string
  userName: string
  time: string
  needsHuman?: boolean
}): ReactElement {
  return (
    <ChatBubble
      data-testid="inbound-bubble"
      text={text}
      userName={userName}
      time={time}
      bubbleSx={{ borderTopLeftRadius: 0, backgroundColor: 'white15' }}
      containerSx={{ alignItems: 'flex-start' }}
      needsHuman={needsHuman}
    />
  )
}
